import { ProductType } from '@/shared/enums';

const swapSerialProperties = (item) => (
  item?.type !== ProductType.EPISODE
    ? item
    : {
      ...item,
      images: item.season.serial.images,
      lead: item.season.serial.lead,
    });

const findBookmarkForEpisode = (episodesBookmarks, episodeId) => {
  return episodesBookmarks.find(
    ({ id, bookmark }) => id === episodeId && !bookmark.watched,
  );
};

const swapWatchedEpisodes = (item, episodesBookmarks) => {
  const { type, bookmark, bookmark: { watched }, nextEpisode, rating, season } = item;

  if (type !== ProductType.EPISODE || !watched) {
    return item;
  }

  if (!nextEpisode) {
    return null;
  }

  const destItem = findBookmarkForEpisode(episodesBookmarks, nextEpisode.id) || nextEpisode;

  return {
    ...destItem,
    type,
    rating,
    season: {
      serial: season.serial,
      number: destItem.seasonNumber || season.number,
    },
    bookmark: destItem.bookmark || {
      ...bookmark,
      playTime: 0,
      progress: 0,
    },
  };
};

export default (bookmarks = [], episodesBookmarks = []) => {
  return bookmarks
    .map((item) => swapWatchedEpisodes(item, episodesBookmarks))
    .map(swapSerialProperties)
    .filter(Boolean);
};
